import _defineProperty from "/home/runner/work/design/design/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/home/runner/work/design/design/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["icon"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import styled from 'styled-components';
import sx from './sx';

function Octicon(_ref) {
  var IconComponent = _ref.icon,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(IconComponent, rest);
}

Octicon.displayName = "Octicon";
var StyledOcticon = styled(Octicon).withConfig({
  displayName: "StyledOcticon",
  componentId: "sc-1lhyyr-0"
})(["", ""], function (_ref2) {
  var color = _ref2.color,
      sxProp = _ref2.sx;
  return sx({
    sx: _objectSpread({
      color: color
    }, sxProp)
  });
});
StyledOcticon.defaultProps = {
  size: 16
};
export default StyledOcticon;